import { render, staticRenderFns } from "./ednCat.vue?vue&type=template&id=6f112667&scoped=true"
import script from "./ednCat.vue?vue&type=script&lang=js"
export * from "./ednCat.vue?vue&type=script&lang=js"
import style0 from "./ednCat.vue?vue&type=style&index=0&id=6f112667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f112667",
  null
  
)

export default component.exports